import { DEFAULT_API_TIMEOUT } from "@nib-group/chatbot-shared/fetch";
export default {
  MINIMUM_LOADING_TIME: 2000,
  // ms
  IFRAME_LOAD_TIMEOUT: DEFAULT_API_TIMEOUT,
  SIZE: {
    MOBILE_WIDTH: "calc(100vw - 40px)",
    // px
    MOBILE_HEIGHT: "calc(80vh)",
    TABLET_WIDTH: "400px",
    TABLET_HEIGHT: "550px",
    DESKTOP_WIDTH: "465px",
    DESKTOP_HEIGHT: "645px"
  }
};